import { LoadingButton } from "@mui/lab";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { capitalize, filter } from "lodash";
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import GroupsIcon from '@mui/icons-material/Groups'
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useState } from "react";
import { _editGroupChat, _getChatTeamList } from "src/DAL";
import { Iconify, MuiDialog, MuiDrawer, Scrollbar, UserAvatar } from "src/components";
import ImageSelector from "src/components/ImageSelector";
import StyledChatSearch from "src/components/search/StyledChatSearch";
import { s3baseUrl } from "src/config";
import { useAppContext } from "src/hooks";
import { upload_image } from "src/utils";
import { capitalizeAllWords } from "src/utils/stringFunctions";
import LabelRole from "src/components/LabelRole";

function GroupInfoDrawer({ isInfoDrawerOpen, setIsInfoDrawerOpen, handleAddNewChat, chatList }) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    currentChat,
    dispatch_get_user_profile,
    getModifiedChatItem,
    setCurrentChat,
    setChatList,
    socketEmit,
  } = useAppContext();
  const [groupName, setGroupName] = useState(capitalizeAllWords(currentChat?.label));
  const [oldImage, setOldImage] = useState(currentChat.image);
  const [checked, setChecked] = useState({});
  const [groupImage, setGroupImage] = useState(currentChat.image);
  const [searchValue, setSearchValue] = useState("");
  const [teamList, setTeamList] = useState([]);
  const [groupMemberList, setGroupMemberList] = useState([]);
  const [otherMemberList, setOtherMemberList] = useState([]);
  const [teamLoading, setTeamLoading] = useState(true);
  const [isEditingGroupName, setIsEditingGroupName] = useState(false);
  const [isEditingImage, setIsEditingImage] = useState(false);
  const [hoveredUserId, setHoveredUserId] = useState();
  const [isOpenAddUser, setIsOpenAddUser] = useState(false);
  const [isHoveredonImage, setIsHoveredonImage] = useState(false);
  const [ischangedGroupedMember, setIschangedGroupedMember] = useState(false);
  const [deleteChatDialogOpen, setDeleteChatDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState();

  useEffect(() => {
    if (currentChat) {
      setGroupName(capitalizeAllWords(currentChat?.label));
      setGroupImage(currentChat?.image);
      setOldImage(currentChat?.image);
    }
  }, [currentChat]);
  const fetchTeam = async () => {
    // setTeamLoading(true);
    const result = await _getChatTeamList();
    if (result.code === 200) {
      setTeamList(
        result.chat_team_list
      );
      // setGroupMemberList(result.chat_team_list);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    // setTeamLoading(false);
  };
  const getFilteredList = (data) => {
    if (!data) {
      return [];
    }
    if (searchValue === "") {
      return data;
    }
    if (searchValue !== "") {
      let filtered = handleLocalChatSearch(searchValue, data);
      return filtered;
    }
  };
  const handleLocalChatSearch = (input, array) => {
    const get_merged = (item) => {
      return `${item.first_name} ${item.last_name}`;
    };
    let filtered = filter(
      array,
      (item) =>
        get_merged(item).toLowerCase().indexOf(input.toLowerCase()) !== -1
    );
    return filtered;
  };
  function handleToggle(item) {
    console.log("called................");

    if (!checked[item.user_id]) {
      const temp = { ...item };
      delete temp.allow_add_project;
      delete temp.allow_drag_drop;
      delete temp._id;
      delete temp.leave_reason;

      setChecked((prev) => ({
        ...prev,
        [item.user_id]: temp,
      }));
    } else {
      const temp = { ...checked };
      delete temp[item.user_id];
      setChecked(temp);
    }
  }
  /////////////////Update Group//////////////////////////////////
  const [updateLoading, setUpdateLoading] = useState(false);
  const handleUpdateGroup = async (e) => {
    e && e.preventDefault();
    setUpdateLoading(true);
    try {
      if (Object.keys(checked).length == 0) {
        enqueueSnackbar("Please select atleast one member", {
          variant: "error",
        });
        return;
      }
      if (groupName.trim() == "") {
        enqueueSnackbar("Please provide valid group name", {
          variant: "error",
        });
        return;
      }
      let image = oldImage;
      console.log(groupImage, "group image.............", oldImage);

      if (!groupImage) {
        image = "";
      }
      else if (groupImage instanceof File) {
        const imageResult = await upload_image(groupImage);
        if (imageResult.code == 200) {
          image = imageResult.path;
        }
      } else {
        image = groupImage?.replace(s3baseUrl, "");
      }
      // let image = oldImage;
      // if (!image) {
      //   image = "";
      //   console.log("called 1...........", image);

      // }
      // else if (image instanceof File) {
      //   console.log("called 2...........", image);
      //   const imageResult = await upload_image(image);
      //   if (imageResult.code == 200) {
      //     image = imageResult.path;
      //   }
      // } else {
      //   console.log("called 3...........", image);
      //   image = image?.replace(s3baseUrl, "");
      // }
      const req_obj = {
        group_name: groupName,
        group_image: image,
        start_time: "",
        end_time: "",
        team: Object.values(checked),
      };
      console.log("Data before editing group", currentChat._id, req_obj);

      const result = await _editGroupChat(currentChat._id, req_obj);
      if (result.code == 200) {
        enqueueSnackbar(result.message, { variant: "success" });
        setCurrentChat(getModifiedChatItem(result.group));
        let groupUserList = getModifiedChatItem(result.group).user.filter((singleUser) => {
          return singleUser.user_id !== dispatch_get_user_profile().user_id;
        });
        console.log(groupUserList, "updated liost..........");

        setGroupMemberList(groupUserList);
        console.log("chatlist updated no: 51");
        setChatList((prev) => {
          return prev.map((chat) => {
            if (chat._id == result.group._id) {
              return { ...getModifiedChatItem(result.group) };
            } else {
              return { ...chat };
            }
          });
        });
        // setIsInfoDrawerOpen(false);
        socketEmit("updateNewChat", result.group);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, " error catched while updating the group");
    } finally {
      setUpdateLoading(false);
    }
  };


  const handleRemoveMember = (item) => {
    console.log("Removing:", item);
    setGroupMemberList(groupMemberList.filter((user) => {
      return user.user_id !== item.user_id;
    }))
    handleToggle(item);
  };

  function handleCloseDrawer() {
    setGroupImage(currentChat.image);
    if (ischangedGroupedMember) {
      handleUpdateGroup();
      setIschangedGroupedMember(false);
    }
    setIsEditingGroupName(false);
    setIsInfoDrawerOpen(false);
  }
  ///////////////////////////////////////////////////////////////

  useEffect(() => {
    let newArray = [];

    teamList.map((user) => {
      let findedUser = groupMemberList.find((item) => {
        return item.user_id === user.user_id;
      });

      if (!findedUser) {
        newArray.push(user);
      }
    });
    setOtherMemberList(newArray);
  }, [groupMemberList, teamList]);

  useEffect(() => {
    if (isInfoDrawerOpen) {
      fetchTeam();
      const newChecked = {};
      currentChat?.member_user?.forEach((member) => {
        const { _id, ...rest } = member;
        newChecked[member.user_id] = rest;
      });
      setChecked(newChecked);
      // currentChat.user.map((member) => {
      //   delete member._id;
      //   setChecked((prev) => {
      //     return {
      //       ...prev,
      //       [member.user_id]: member,
      //     };
      //   });
      // });
    }
  }, [isInfoDrawerOpen]);

  useEffect(() => {
    setGroupMemberList(currentChat?.member_user);
    setTeamLoading(false);
  }, [currentChat]);

  return (
    <MuiDrawer
      paperProps={{ width: { xs: 1, sm: 340 } }}
      isOpen={isInfoDrawerOpen}
      onClose={() => {
        handleCloseDrawer();
      }}
      title={<Typography sx={{ fontWeight: "700" }}>Group Info</Typography>}
      bottomComponent={
        currentChat?.creator_id == dispatch_get_user_profile().user_id && (
          <div
            className="d-flex justify-content-center bottom-component"
          >
            <LoadingButton
              variant="contained"
              loading={updateLoading}
              onClick={() => {
                setIsEditingImage(false);
                setIsOpenAddUser(true);
              }}
            >
              Add Participant
            </LoadingButton>
          </div>
        )
      }
    >
      {currentChat?.creator_id == dispatch_get_user_profile().user_id && (
        <div>
          <div className="group-name-container">
            <div
              className="my-2 w-100 d-flex justify-content-center position-relative"
            >
              <div>
                <Avatar src={oldImage} className="chat-avatar-extra-large" >
                  <GroupsIcon sx={{ fontSize: 44 }} />
                </Avatar>
                <Tooltip
                  arrow
                  title="Edit Image"
                >
                  <IconButton size="small" className="my-2 editing-group-image" onClick={() => {
                    setIsEditingImage(true);
                    setIsOpenAddUser(true);
                  }}>
                    <EditIcon sx={{ fontSize: 15 }} />
                  </IconButton>
                </Tooltip>
              </div>
              {/* <div className="position-relative"
                onMouseEnter={() => {
                  setIsHoveredonImage(true);
                }}
                onMouseLeave={() => {
                  setIsHoveredonImage(false);
                }}>
                <Avatar src={oldImage} className="chat-avatar-extra-large" >
                  <GroupsIcon sx={{ fontSize: 44 }} />
                </Avatar>
                {isHoveredonImage && <IconButton size="small" className="my-2 editing-group-image" onClick={() => {
                  setIsEditingImage(true);
                  setIsOpenAddUser(true);
                }}>
                  <EditIcon sx={{ fontSize: 26, color: "#00AB55" }} />
                </IconButton>}
              </div> */}
            </div>
          </div>
          <div className="col-12 group-name-container">
            {!isEditingGroupName ?
              <div className="mt-2 w-100 d-flex justify-content-center position-relative">
                <Typography fontWeight="bold" className="my-2 group-heading" textAlign="center">{groupName}</Typography>
                {/* <Typography variant="h6" fontWeight="600" className="my-2 group-heading" textAlign="center">
                  {groupName}
                </Typography> */}
                <Tooltip
                  arrow
                  title="Edit Group Name"
                >
                  <IconButton size="small" className="my-2 editing-group-name edit-group-icon" onClick={() => {
                    setIsEditingGroupName(true);
                  }}>
                    <EditIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
              </div> :
              <div className="mt-2 w-100 d-flex justify-content-center align-items-center">
                <TextField
                  label="Group Name"
                  fullWidth
                  required
                  size="small"
                  name="name"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  type="text"
                  className="my-2 me-1"
                /><Tooltip
                  arrow
                  title="Save"
                >
                  <IconButton size="small" className="my-2 editing-group-name"
                    onClick={(e) => {
                      setGroupImage(oldImage);
                      setIsEditingGroupName(false);
                      handleUpdateGroup(e);
                    }}
                  >
                    <CheckCircleIcon sx={{ fontSize: 19 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  title="Cancel"
                >
                  <IconButton size="small" className="my-2 editing-group-name"
                    onClick={(e) => {
                      setIsEditingGroupName(false);
                    }}
                  >
                    <CancelIcon sx={{ fontSize: 19 }} />
                  </IconButton>
                </Tooltip>
              </div>
            }
          </div>

          <hr className="mt-0" />
          {/* <Typography fontWeight="500" className="my-2">
            {groupMemberList.length} Participants
          </Typography> */}
          {!teamLoading && <Typography>{groupMemberList.length} Participants</Typography>}
          {!teamLoading ?
            <Scrollbar sx={{ height: "calc(100vh - 315px)" }}>
              <List
                dense
                sx={{
                  width: "100%",
                  maxWidth: 550,
                  bgcolor: "background.paper",
                }}
                className="group-info-list"
              >
                {getFilteredList(groupMemberList)
                  .sort((a, b) => (a.user_id === currentChat?.creator_id ? -1 : b.user_id === currentChat?.creator_id ? 1 : 0))
                  .map((item, index) => {
                    return (
                      <ListItem
                        key={index + item.user_id}
                        disablePadding
                        onMouseEnter={() => {
                          setHoveredUserId(item.user_id);
                        }}
                        onMouseLeave={() => {
                          setHoveredUserId();
                        }}
                        secondaryAction={
                          hoveredUserId == item.user_id && currentChat?.creator_id !== item.user_id &&
                          <LoadingButton
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              setSelectedUser(item);
                              setDeleteChatDialogOpen(true);
                              // handleRemoveMember(item);
                            }}
                            sx={{
                              fontSize: '9px',
                              position: 'relative',
                              left: '15px'
                            }}
                          >
                            Remove
                          </LoadingButton>
                        }
                      >
                        <ListItemButton className="px-0 py-2" >
                          <ListItemAvatar>
                            {item.image !== "" ? (
                              <Tooltip
                                arrow
                                title={`${capitalize(item.first_name)} ${capitalize(item.last_name)}`}
                              >
                                <Avatar
                                  alt={item.first_name}
                                  src={s3baseUrl + item.image}
                                  className="chat-avatar"
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip
                                arrow
                                title={`${capitalize(item.first_name)} ${capitalize(item.last_name)}`}
                              >
                                <Avatar alt="Remy Sharp" className="chat-avatar">
                                  {capitalize(item.first_name.substring(0, 1))}
                                </Avatar>
                              </Tooltip>
                            )}
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography variant="body2">
                                {capitalize(item.first_name) + " " + capitalize(item.last_name)}
                                
                                {currentChat?.creator_id == item.user_id ? <LabelRole sx={{marginLeft: "8px"}} role={"admin"}>Admin</LabelRole> : ""}
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
              </List>
            </Scrollbar>
            :
            <div className="d-flex h-100 justify-content-center align-items-center" style={{ height: "250px" }}>
              <CircularProgress />
            </div>
          }
        </div>

      )}
      {currentChat.creator_id !== dispatch_get_user_profile().user_id && (
        <div>

          <div className="d-flex justify-content-center mb-2">
            <Avatar src={oldImage} className="chat-avatar-extra-large" >
              <GroupsIcon sx={{ fontSize: 44 }} />
            </Avatar>
            {/* <img
                src={groupImage}
                className="group-image"
              /> */}
          </div>
          <Typography variant="h6" fontWeight="600" className="mb-2" textAlign="center">
            {capitalizeAllWords(currentChat?.label)}
          </Typography>
          <div className="search-user-list row mb-3">
            <span className="col-12 search-user-list-span">
              <StyledChatSearch
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeHolder="Search Members..."
              />
            </span>
          </div>
          {!teamLoading && <Typography>{groupMemberList.length} Participants</Typography>}
          {!teamLoading ?
            <Scrollbar sx={{ height: "calc(100vh - 330px)" }}>
              <List
                dense
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                }}
                className="group-info-list"
              >
                {getFilteredList(groupMemberList)
                  .sort((a, b) => (a.user_id === currentChat?.creator_id ? -1 : b.user_id === currentChat?.creator_id ? 1 : 0))
                  .map((item) => {
                    return (
                      <ListItem key={item.user_id} disablePadding>
                        <ListItemButton className="px-0 py-2" onClick={() => {
                          let newChat = chatList.find(
                            (obj) => { obj.type == 0 && obj.user[0].user_id == item.user_id }
                          );
                          console.log(item, "selected user");
                          handleAddNewChat(item);
                          // onChatClick(newChat);
                          setIsInfoDrawerOpen(false);
                          // const clickedUser = chatList.find((i) => i.creator_id === item.user_id);
                          // onChatClick(clickedUser);
                        }}>
                          <ListItemAvatar>
                            {item.image !== "" ? (
                              <Tooltip
                                arrow
                                title={`${item.first_name} ${item.last_name}`}
                              >
                                <Avatar
                                  alt={item.first_name}
                                  src={s3baseUrl + item.image}
                                  className="chat-avatar"
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip
                                arrow
                                title={`${item.first_name} ${item.last_name}`}
                              >
                                <Avatar alt="Remy Sharp" className="chat-avatar">
                                  {capitalize(item.first_name.substring(0, 1))}
                                </Avatar>
                              </Tooltip>
                            )}
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography variant="body2">
                                {capitalize(item.first_name) + " " + capitalize(item.last_name)}
                                {currentChat?.creator_id == item.user_id ? <LabelRole sx={{marginLeft: "8px"}} role={"admin"}>Admin</LabelRole> : ""}
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
              </List>
            </Scrollbar>
            :
            <div className="d-flex justify-content-center align-items-center" style={{ height: "250px" }}>
              <CircularProgress />
            </div>
          }
        </div>
      )}
      <Dialog
        open={isOpenAddUser}
        onClose={() => {
          setGroupImage(oldImage);
          setIsOpenAddUser(false);
        }}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle className="mb-0 pb-0">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {isEditingImage ? "Change Group Image" : "Select Participants"}
            <IconButton size="small" onClick={() => {
              setGroupImage(oldImage);
              setIsOpenAddUser(false);
            }}>
              <Iconify
                icon="ion-close"
                sx={{ height: "20px", width: "20px" }}
              />
            </IconButton>
          </Box>
          {isEditingImage && <hr />}
        </DialogTitle>

        <DialogContent sx={{ padding: "0px 20px 20px 20px" }}>
          {isEditingImage ?
            <div >
              <div className="d-flex justify-content-center">
                <div style={{ maxWidth: "300px" }}>
                  <ImageSelector
                    file={groupImage}
                    setFile={setGroupImage}
                    currentImage={oldImage}
                    removeCurrentImage={() => { }}
                  />
                </div>
              </div>
              <div
                className="d-flex justify-content-end"
              >
                <LoadingButton
                  className="mt-2"
                  variant="contained"
                  loading={updateLoading}
                  onClick={(e) => {
                    console.log(groupImage, "hihihihi", oldImage);
                    handleUpdateGroup(e);
                    setIsOpenAddUser(false);
                    // setIsEditingImage(false);
                  }}
                >
                  Update Image
                </LoadingButton>
              </div>
            </div> :
            <>
              <div className="search-user-list row mt-2 mb-2">
                <span className="col-12 search-user-list-span">
                  <StyledChatSearch
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeHolder="Search Members..."
                  />
                </span>
              </div>
              <Scrollbar sx={{ height: "calc(100vh - 500px)" }}>
                <List
                  dense
                  sx={{
                    width: "100%",
                    maxWidth: 550,
                    bgcolor: "background.paper",
                  }}
                >
                  {otherMemberList.length > 0 ? getFilteredList(otherMemberList).map((item, index) => {
                    return (
                      <ListItem
                        key={index + item._id}
                        onClick={() => {
                          handleToggle(item)
                        }}
                        disablePadding
                      >
                        <ListItemButton className="px-1 py-1">
                          <Checkbox
                            edge="start"
                            checked={checked[item.user_id] ? true : false}
                            tabIndex={-1}
                            disableRipple
                            className="me-1"
                          />
                          <ListItemAvatar className="me-2">
                            {item.image !== "" ? (
                              <Tooltip
                                arrow
                                title={`${item.first_name} ${item.last_name}`}
                              >
                                <Avatar
                                  alt="Remy Sharp"
                                  src={s3baseUrl + item.image}
                                  className="chat-avatar"
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip
                                arrow
                                title={`${item.first_name} ${item.last_name}`}
                              >
                                <Avatar className="chat-avatar">
                                  {capitalize(item.first_name.substring(0, 1))}
                                </Avatar>
                              </Tooltip>
                            )}
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography variant="body2">
                                {capitalize(item.first_name) + " " + capitalize(item.last_name)}
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })
                    :
                    <Typography variant="body2">
                      No more participant are found to add in this Group
                    </Typography>}
                </List>
              </Scrollbar>

              <div
                className="d-flex justify-content-end"
              >
                {otherMemberList.length > 0 ? <LoadingButton
                  variant="contained"
                  loading={updateLoading}
                  onClick={(e) => {
                    handleUpdateGroup(e);
                    setIsOpenAddUser(false);
                  }}
                >
                  Add Participant
                </LoadingButton>
                  :
                  <LoadingButton
                    variant="outlined"
                    loading={updateLoading}
                    onClick={(e) => {
                      setIsOpenAddUser(false);
                    }}
                  >
                    Close
                  </LoadingButton>}
              </div></>
          }
        </DialogContent>
      </Dialog>
      <MuiDialog
        open={deleteChatDialogOpen}
        title={"Remove User"}
        message={`Are you sure you want to remove "${capitalize(selectedUser?.first_name)} ${capitalize(selectedUser?.last_name)}" From this Group?`}
        onAgree={() => {
          setIschangedGroupedMember(true);
          handleRemoveMember(selectedUser);
          setDeleteChatDialogOpen(false);
        }}
        onToggle={() => setDeleteChatDialogOpen(false)}
        loading={false}
      />
    </MuiDrawer>
  );
}

export default GroupInfoDrawer;
